<template>
    <div>
        <div class="mainwrap">
            <keep-alive exclude="">
                <router-view class="router_contents" :key="$route.fullPath" :style="{ paddingTop: $GlobalStore.statusBarHeight() + 'px', paddingBottom: $GlobalStore.navigationBarHeight() + 'px' }"></router-view>
            </keep-alive>
        </div>
        <div class="modaldiv">
            <transition-group :name="$GlobalStore.modalTransitionName()">
                <div v-for="each, index in $store.state.modals" class="each_modal" :key="each.view + index" :ref="'modalRef' + index" :style="{
                    backgroundColor: each.isModalBackTransparent ? 'transparent' : ''
                }">
                    <div class="bounce_back_cover" :ref="'modalRefBack' + index" :style="{ backgroundColor: each.isModalBackTransparent ? 'transparent' : '' }"></div>
                    <!--<div class="modal">-->
                    <component class="modal" :is="each.view" v-bind="each"></component>
                    <!--</div>-->

                </div>
            </transition-group>
        </div>
        <PrivacyPolicy :isShowPrivacyPolicy="$GlobalStore.isShowPrivacyPolicy()" :closePrivacyPolicy="$GlobalStore.closePrivacyPolicy"></PrivacyPolicy>
    </div>
</template>

<script>
import TestModal from './modal/TestModal'
import FindPositionLite from './page/FindPositionLite';
import PrivacyPolicy from './common/PrivacyPolicy';

export default {
    name: "PageFrame",
    // mixins : [commonmix],
    components: {
        TestModal, FindPositionLite, PrivacyPolicy
    },
    computed: {
        is_app() {
            const device = this.$cookies.get('device');
            return device === 'ios' || device === 'android';
        }
    },
    data: function () {
        return {
            addPushDeviceCnt: 0,
            isShowCoachAgreement: false,
            is_loaded: false,
            device_type: null
        }
    },
    methods: {
        async getDefaultData() {

        },

    },
    mounted: function () {
        this.$store.commit('setModalInstance', this);
    },
    created: function () {

    }
}
</script>

<style scoped>
.bounce_back_cover {
    position: fixed;
    left: 0px;
    top: 0px;
    bottom: 0px;
    width: 100vw;
    background-color: white;
    display: none;
}

.mainwrap {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.mainwrap_pc {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    max-width: 600px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.router_contents {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    left: 0%;
    background-color: white;
    overflow: hidden;
}

.leftmenu {
    position: fixed;
    height: 100%;
    left: 0%;
    top: 0px;
    width: 100%;
    /*z-index:10;*/
}

.leftmenu_list {
    position: absolute;
    left: 0px;
    top: 0px;
    height: 100%;
    width: 300px;
    background-color: #2F4050;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.leftmenu_back {
    position: fixed;
    height: 100%;
    left: 0%;
    top: 0px;
    width: 100%;
    background-color: black;
    opacity: 0.5
}

.each_modal {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    background-color: white;
}

.each_modal_pc {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    bottom: 0;
    width: 100vw;
    max-width: 600px;
    background-color: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.modal {
    height: 100%;
    display: flex;
    flex-direction: column;
    /*background-color:rgb(241, 241, 241);*/
}

.right-enter-active,
.right-leave-active {
    transition: left .3s;
}

.right-enter,
.right-leave-to {
    left: 100%;
}

.rightPc-enter-active,
.rightPc-leave-active {
    transition: left 0.3s;
}

.rightPc-enter,
.rightPc-leave-to {
    left: 150%;
}

.bottom-enter-active,
.bottom-leave-active {
    transition: top .5s;
}

.bottom-enter,
.bottom-leave-to {
    top: 100%;
}

.fade2-enter-active,
.fade2-leave-active {
    transition: opacity 0.5s;
}

.fade2-enter,
.fade2-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: left .3s;
}

.fade-enter,
.fade-leave-to {
    left: -100%;
}

.leftmenuright-enter-active,
.leftmenuright-leave-active {
    transition: transform 0.3s;
}

.leftmenuright-enter,
.leftmenuright-leave-to {
    transform: translateX(100%);
}

.leftmenu_bottom {
    height: 55px;
}

.leftmenu_each_modal {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 300px;
    height: 100%;
}

.fadeTop2-enter-active,
.fadeTop2-leave-active {
    transition: all .5s;
}

.fadeTop2-enter,
.fadeTop2-leave-to {
    top: 100%;
    opacity: 0;
}
</style>
